import localeService from 'commons/localeService/localeService';
import { Base64 } from 'js-base64';
import apiClient from 'commons/api/client/apiClient';
import store from 'commons/store/Store';

const accountService = {
  async deleteAccount(password) {
    const config = {
      params: {
        locale: localeService.convertToSprdLocale(localeService.getLocale()),
      },
      headers: {
        'password-base64': Base64.encode(password),
        'Content-Type': 'application/json',
      },
      data: {},
    };

    await apiClient.request({
      method: 'DELETE',
      url: `rest/user/${store.state.user.data.id}/account`,
      ...config,
    });
    return store.dispatch('user/logout');
  },
};

export default accountService;
